// eslint-disable-next-line max-classes-per-file
import * as config from 'Config/fishnetUrls';
import lcrRequest from '../lcrRequest';
import getTimezone from '../helpers/helpers';

const defaultOptions = {
  tz: getTimezone(),
};

export class ClientMatchIdAPI {
  constructor(path, options = defaultOptions) {
    const opt = { ...defaultOptions, ...options };
    const urlBase = config.fishnetOddsFeedsUrl;
    this.url = `${urlBase}${opt.alias}/${opt.language}/${opt.tz}/gismo/${path}`;
  }

  get() {
    return lcrRequest
      .get(this.url)
      .then(data => {
        if (!data || (data && data.error)) {
          throw data;
        }
        return data;
      }).catch(e => {
        throw new Error(`Client Match ID API Request error: ${e}`);
      });
  }
}

export class ClientMatchIdRequest extends ClientMatchIdAPI {
  constructor(matchId, alias, language) {
    super(`match_idmapping/${matchId}`, { alias, language });
  }
}
